<template>
  <el-dialog
    :visible.sync="visible"
    :close-on-click-modal="false"
    :show-close="false"
    :custom-class="'confirm-dialog'"
    :width="width"
    @close="onCancel"
      append-to-body
  >
    <div class="dialog-card">
      <!-- 自定义关闭按钮 -->
      <button class="close-btn" @click="onCancel" aria-label="close">
        <i class="el-icon-close"></i>
      </button>

      <!-- 标题 -->
      <div class="dialog-title">{{ computedTitle }}</div>

      <!-- 内容 -->
      <div v-if="type === 'edit-title'" class="dialog-input-wrapper">
        <el-input
          v-model="inputValue"
          :placeholder="placeholder || '请输入新标题'"
          class="custom-input"
        ></el-input>
      </div>
      <div v-else class="dialog-message" v-html="computedMessage"></div>

      <!-- 底部按钮 -->
      <div class="dialog-footer">
        <el-button
          v-if="type != 'doNotDeletePrompt'"
          class="btn cancel-btn"
          @click="onCancel"
        >
          {{ cancelText }}
        </el-button>
        <el-button
          class="btn confirm-btn"
          :class="confirmClass"
          @click="onConfirm"
        >
          {{ confirmText }}
        </el-button>
      </div>
    </div>
  </el-dialog>
</template>

<script>
export default {
  name: "ConfirmDialog",
  props: {
    visible: { type: Boolean, default: false },
    type: { type: String, default: "delete-history" },
    sceneType: { type: Object, default: {} },
    width: { type: [String, Number], default: "28.57143rem" },
    titleText: { type: String, default: "" },
    messageText: { type: String, default: "" },
    value: { type: String, default: "" }, // 编辑标题初始值
    placeholder: { type: String, default: "" },
  },
  data() {
    return {
      inputValue: this.value,
    };
  },
  watch: {
    value(val) {
      this.inputValue = val;
    },
  },
  computed: {
    computedTitle() {
      if (this.titleText) return this.titleText;
      const map = {
        "delete-history": "删除此对话？",
        logout: this.$t("confirmDialog.logout.title"),
        "delete-user": "确定删除用户？",
        "clear-all-history": "清空全部历史记录",
        insufficientPoints: "积分不足",
        "edit-title": "编辑标题",
        activateMembership: "您还不是会员，仅会员可购买加量包",
        deleteScene: "删除场景",
        doNotDeletePrompt: "提示",
        deleteVideo: "删除视频",
        deleteScript: "删除脚本",
      };
      return map[this.type] || "";
    },
    computedMessage() {
      if (this.messageText) return this.messageText;
      const map = {
        "delete-history": "这条会话将被永久删除，不可恢复及撤销",
        logout: this.$t("confirmDialog.logout.message"),
        "delete-user": "用户信息将被删除，保留操作和充值记录",
        "clear-all-history": "全部会话记录将被永久删除，不可恢复及撤销",
        insufficientPoints: "积分不足，请充值",
        activateMembership: "是否开通会员？",
        deleteScene: `确定要删除场景${this.sceneType.index + 1}？`,
        doNotDeletePrompt: "至少需要保留一个场景",
        deleteVideo: "确定要删除视频？视频删除后不可找回",
        deleteScript: "确定要删除脚本？脚本删除后不可找回",
      };
      return map[this.type] || "";
    },
    cancelText() {
      return this.type === "logout" ? this.$t("common.cancel") : "取消";
    },
    confirmText() {
      const map = {
        "delete-history": "删除",
        logout: this.$t("confirmDialog.logout.confirm"),
        "delete-user": "删除",
        "clear-all-history": "清空",
        "edit-title": "确定",
        insufficientPoints: "去充值",
        activateMembership: "去开通",
        doNotDeletePrompt: "确定",
        deleteVideo:'确定',
        deleteScript:'确定'
      };
      return map[this.type] || "确定";
    },
    confirmClass() {
      if (this.type === "logout") return "logout";
      if (this.type === "edit-title") return "black";
      return "danger";
    },
  },
  methods: {
    onCancel() {
      this.$emit("update:visible", false);
      this.$emit("cancel", { type: this.type });
    },
    onConfirm() {
      this.$emit("update:visible", false);
      if (this.type === "edit-title") {
        this.$emit("confirm", { type: this.type, value: this.inputValue });
      }else if(this.type === "deleteVideo" || this.type === "deleteScript"){
        this.$emit("confirm", { type: this.type, name: this.sceneType.taskId });
      }else if(this.type === "deleteScene"){
        this.$emit("confirm", { type: this.type, name: this.sceneType.index });
      } else {
        this.$emit("confirm", { type: this.type });
      }
    },
  },
};
</script>

<style scoped lang="less">
/* 尺寸按设计稿 px/14 转 rem；字号用 max(12PX, Nrem) 保证小屏不低于 12px */
/* 去掉 el-dialog body 默认 padding */
/deep/ .confirm-dialog {
  border-radius: 0.71429rem;
  .el-dialog__body {
    padding: 0;
  }
  .el-dialog__header {
    padding: 0;
  }
  .el-button + .el-button {
    margin-left: 0;
  }
}

/* 卡片样式 */
.dialog-card {
  background: #fff;
  border-radius: 0.85714rem;
  box-shadow: 0 0.57143rem 2rem rgba(0, 0, 0, 0.12);
  padding: 1.42857rem 1.42857rem 1.28571rem 1.42857rem;
  position: relative;
  font-family: "Helvetica Neue", "PingFang SC", "Microsoft YaHei", Arial,
    sans-serif;
}

/* 关闭按钮 */
.close-btn {
  position: absolute;
  right: 1rem;
  top: 1rem;
  width: 2.28571rem;
  height: 2.28571rem;
  border: none;
  background: transparent;
  cursor: pointer;
  outline: none;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #999;
  font-size: ~"max(12PX, 1.14286rem)";
  border-radius: 50%;
}
.close-btn:hover {
  color: #666;
  background: rgba(0, 0, 0, 0.04);
}

/* 标题 */
.dialog-title {
  font-size: ~"max(12PX, 1.28571rem)";
  font-weight: 600;
  line-height: 1.71429rem;
  color: #222;
  padding-right: 3.42857rem;
  margin-bottom: 0.85714rem;
}

/* 内容文字 */
.dialog-message {
  font-size: ~"max(12PX, 0.92857rem)";
  color: #7a7a7a;
  line-height: 1.42857rem;
  margin-bottom: 1.42857rem;
  white-space: pre-wrap;
}

/* 编辑标题模式输入框 */
.dialog-input-wrapper {
  margin-bottom: 1.42857rem;
}
.custom-input .el-input__inner {
  border-radius: 0.71429rem;
  background-color: #f5f5f5;
  border: none;
  height: 2.71429rem;
  font-size: ~"max(12PX, 1rem)";
  padding: 0 0.85714rem;
}

/* 底部按钮区 */
.dialog-footer {
  display: flex;
  justify-content: flex-end;
  gap: 0.85714rem;
}

/* 按钮样式 */
.btn {
  min-width: 6.42857rem;
  height: 2.57143rem;
  padding: 0 1.28571rem;
  border-radius: 0.71429rem;
  font-size: ~"max(12PX, 1rem)";
  line-height: 2.57143rem;
}
.cancel-btn {
  background: #fff;
  border: 1px solid #e6e6e6;
  color: #333;
}
.confirm-btn.danger {
  background: #fff;
  border: 1px solid #ff4d4f;
  color: #ff4d4f;
  font-weight: 500;
}
.confirm-btn.logout {
  background: #5e7bfe;
  color: #fff;
  border: none;
}
.confirm-btn.black {
  background: #000;
  color: #fff;
  border: none;
}
.cancel-btn:hover {
  background: #fafafa;
}
.confirm-btn:hover {
  filter: brightness(0.96);
}
</style>
